import axios from "../../../util/axios";

export default {
    /** 查询配置 */
    findSetting: (pageName) => axios.get({url: "/basedata/system/mini/setting/findSetting", data: {pageName}}),
    /** 保存配置 */
    saveSetting: (data) => axios.post({url: "/basedata/system/mini/setting/saveSetting", data: data}),


}